"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedRadioPropTypes = exports.radioPropTypes = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _interfaces = require("./interfaces");
const sharedRadioPropTypes = exports.sharedRadioPropTypes = {
  checked: _stencilReactDesc.PropTypes.bool.description('Used when the radio button is controlled, to determine whether it is selected.'),
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.RadioColorScheme)).description('Sets a predefined color scheme to use for the component.'),
  defaultChecked: _stencilReactDesc.PropTypes.bool.description('Selects the radio button by default when the page loads.'),
  id: _stencilReactDesc.PropTypes.string.description('Identifier for the radio button. Must be unique amongst all the form elements on the page.'),
  name: _stencilReactDesc.PropTypes.string.description('Name of the group to place the radio button in. Radio buttons in a group are mutually exclusive and cannot be selected at the same time.')
};
const radioPropTypes = exports.radioPropTypes = {
  ...sharedRadioPropTypes,
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes."),
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the user from interacting with the radio button.'),
  error: _stencilReactDesc.PropTypes.bool.description('Styles the radio button to indicate that the value is incorrect.')
};